jQuery(document).ready(function($) {
    console.log('[Evidence Table Init] Script loaded');
    
    // Initialize simple-datatables on evidence table
    var evidenceDataTable = null;
    var loaderHidden = false;
    
    // Function to hide the loader
    function hideLoader() {
        if (!loaderHidden) {
            var loader = $('#evidence-table-loader');
            if (loader.length) {
                loader.addClass('d-none');
                loaderHidden = true;
                console.log('[Evidence Table Init] Loader hidden');
            }
        }
    }
    
    function initEvidenceTable() {
        console.log('[Evidence Table Init] initEvidenceTable called');
        var table = document.querySelector('#userEvidenceTable');
        console.log('[Evidence Table Init] Table element found:', table);
        console.log('[Evidence Table Init] DataTable available:', typeof DataTable !== 'undefined');
        console.log('[Evidence Table Init] simpleDatatables available:', typeof simpleDatatables !== 'undefined');
        console.log('[Evidence Table Init] window.DataTable available:', typeof window.DataTable !== 'undefined');
        
        if (!table) {
            console.warn('[Evidence Table Init] Table #userEvidenceTable not found in DOM');
            // Hide loader even if table not found
            hideLoader();
            return;
        }
        
        // Check if DataTable is already initialized (has wrapper)
        if (table.closest('.datatable-wrapper')) {
            console.log('[Evidence Table Init] DataTable already initialized (wrapper found), skipping');
            // Hide loader since table is already ready
            setTimeout(function() {
                hideLoader();
            }, 100);
            return;
        }
        
        // Check if we already have an instance
        if (evidenceDataTable) {
            console.log('[Evidence Table Init] DataTable instance already exists, skipping');
            // Hide loader since table is already ready
            setTimeout(function() {
                hideLoader();
            }, 100);
            return;
        }
        
        // Check for DataTable in various possible locations
        var DataTableClass = null;
        if (typeof DataTable !== 'undefined') {
            DataTableClass = DataTable;
            console.log('[Evidence Table Init] Found DataTable in global scope');
        } else if (typeof simpleDatatables !== 'undefined' && simpleDatatables.DataTable) {
            DataTableClass = simpleDatatables.DataTable;
            console.log('[Evidence Table Init] Found DataTable in simpleDatatables');
        } else if (typeof window.DataTable !== 'undefined') {
            DataTableClass = window.DataTable;
            console.log('[Evidence Table Init] Found DataTable in window');
        }
        
        if (!DataTableClass) {
            console.error('[Evidence Table Init] DataTable is not defined. Available globals:', Object.keys(window).filter(k => k.toLowerCase().includes('data')));
            console.error('[Evidence Table Init] typeof simpleDatatables:', typeof simpleDatatables);
            if (typeof simpleDatatables !== 'undefined') {
                console.error('[Evidence Table Init] simpleDatatables keys:', Object.keys(simpleDatatables));
            }
            // Hide loader even if DataTable is not available
            hideLoader();
            return;
        }
        
        try {
            // Destroy existing DataTable if it exists
            if (evidenceDataTable) {
                console.log('[Evidence Table Init] Destroying existing DataTable instance');
                evidenceDataTable.destroy();
                evidenceDataTable = null;
            }
            
            // Store original data before DataTable initialization
            // Store data-framework-id and expiration HTML by row (using first cell content as key)
            var originalRowData = {};
            var rows = table.querySelectorAll('tbody tr');
            rows.forEach(function(row) {
                var firstCell = row.querySelector('td:first-child');
                if (firstCell) {
                    // Get text content (works with or without links)
                    var rowKey = firstCell.textContent.trim();
                    var domainCell = row.querySelector('td:nth-child(4)');
                    var expirationCell = row.querySelector('td:nth-child(6)');
                    
                    if (domainCell) {
                        var frameworkId = domainCell.getAttribute('data-framework-id');
                        if (frameworkId) {
                            originalRowData[rowKey] = originalRowData[rowKey] || {};
                            originalRowData[rowKey].frameworkId = frameworkId;
                        }
                    }
                    
                    if (expirationCell) {
                        originalRowData[rowKey] = originalRowData[rowKey] || {};
                        originalRowData[rowKey].expirationHtml = expirationCell.innerHTML;
                        // Also store data-order attribute for sorting
                        var dataOrder = expirationCell.getAttribute('data-order');
                        if (dataOrder) {
                            originalRowData[rowKey].expirationOrder = dataOrder;
                        }
                    }
                }
            });
            
            console.log('[Evidence Table Init] Initializing DataTable with options:', {
                sortable: true,
                perPage: 25,
                searchable: true
            });
            
            // Initialize simple-datatables
            evidenceDataTable = new DataTableClass(table, {
                sortable: true,
                paging: true,
                perPage: 20,
                perPageSelect: false, // No "entries per page" dropdown; pagination only at bottom
                searchable: true,
                columns: [
                    {
                        select: 0,
                        sort: 'asc' // Sort by Name by default; search uses this column only (partial word match)
                    },
                    {
                        select: 1,
                        searchable: false // Company - exclude from search
                    },
                    {
                        select: 2,
                        searchable: false // Type - exclude from search
                    },
                    {
                        select: 3,
                        type: 'html', // Domain column - preserve HTML
                        searchable: false // Exclude from search
                    },
                    {
                        select: 4,
                        type: 'html', // Role column - preserve badge markup
                        searchable: false, // Exclude from search
                        headerClass: 'user-role',
                        cellClass: 'user-role'
                    },
                    {
                        select: 5,
                        type: 'html', // Expiration column - preserve HTML and classes
                        sortSequence: ['desc', 'asc'], // Default to descending (most recent first)
                        headerClass: 'evidence-expiration text-center', // Preserve CSS class on header and center align
                        cellClass: 'evidence-expiration text-center', // Preserve CSS class on cells and center align
                        searchable: false // Exclude from search
                    },
                    {
                        select: 6,
                        sortable: false,
                        searchable: false, // Actions column
                        headerClass: 'evidence-actions-header text-center', // Preserve CSS class on header and center align
                        cellClass: 'text-center' // Center align actions column
                    }
                ],
                labels: {
                    placeholder: 'Search:',
                    noRows: 'No entries found',
                    info: 'Showing {start} to {end} of {rows} entries'
                }
            });
            
            console.log('[Evidence Table Init] DataTable initialized successfully:', evidenceDataTable);
            
            // Function to restore original data
            function restoreOriginalData() {
                var rowsAfter = table.querySelectorAll('tbody tr');
                rowsAfter.forEach(function(row) {
                    var firstCell = row.querySelector('td:first-child');
                    if (firstCell) {
                        // Get text content (works with or without links)
                        var rowKey = firstCell.textContent.trim();
                        var rowData = originalRowData[rowKey];
                        
                        if (rowData) {
                            // Restore data-framework-id on domain column
                            var domainCell = row.querySelector('td:nth-child(4)');
                            if (domainCell && rowData.frameworkId) {
                                domainCell.setAttribute('data-framework-id', rowData.frameworkId);
                            }
                            
                            // Restore expiration date HTML and data-order attribute
                            var expirationCell = row.querySelector('td.evidence-expiration');
                            if (expirationCell && rowData.expirationHtml) {
                                expirationCell.innerHTML = rowData.expirationHtml;
                                // Restore data-order attribute for sorting
                                if (rowData.expirationOrder) {
                                    expirationCell.setAttribute('data-order', rowData.expirationOrder);
                                }
                            }
                        }
                    }
                });
            }
            
            // Restore original data after DataTable initialization
            setTimeout(restoreOriginalData, 50);
            
            // Listen for DataTable updates to restore data when table is sorted/filtered
            if (evidenceDataTable && typeof evidenceDataTable.on === 'function') {
                evidenceDataTable.on('datatable.update', function() {
                    setTimeout(restoreOriginalData, 10);
                });
            }
            
            // Custom search: match full search string as substring of Name column only (no word-splitting).
            // This ensures "NISC 2017" matches only names containing "NISC 2017", not every row with "NISC".
            (function wireEvidenceNameSearch() {
                var wrapper = table.closest('.datatable-wrapper');
                if (!wrapper) return;
                var searchInput = wrapper.querySelector('.datatable-input');
                if (!searchInput || !evidenceDataTable || !evidenceDataTable.data || !evidenceDataTable.data.data) return;
                var nameCol = 0;
                searchInput.addEventListener('keyup', function nameSearchKeyup(e) {
                    e.stopPropagation();
                    var term = this.value.trim();
                    if (!term) {
                        evidenceDataTable._searchQueries = [];
                        evidenceDataTable._searchData = [];
                        evidenceDataTable._currentPage = 1;
                        evidenceDataTable.update();
                        return;
                    }
                    var data = evidenceDataTable.data.data;
                    var termLower = term.toLowerCase();
                    var matched = [];
                    for (var i = 0; i < data.length; i++) {
                        var cell = data[i][nameCol];
                        var nameText = (cell && (cell.text != null ? cell.text : String(cell.data != null ? cell.data : '')) || '').trim();
                        if (nameText.toLowerCase().indexOf(termLower) !== -1) {
                            matched.push(i);
                        }
                    }
                    evidenceDataTable._searchQueries = [{ term: term, columns: [0] }];
                    evidenceDataTable._searchData = matched;
                    evidenceDataTable._currentPage = 1;
                    evidenceDataTable.update();
                }, true);
            })();

            // Move new-evidence-btn (or new-project-btn) next to the search box
            setTimeout(function() {
                // Find the wrapper that contains our specific table
                var tableWrapper = $(table).closest('.datatable-wrapper');
                if (!tableWrapper.length) {
                    // If table is already inside wrapper, find it differently
                    tableWrapper = $('.datatable-wrapper').has('#userEvidenceTable');
                }
                var searchContainer = tableWrapper.find('.datatable-search');
                var newEvidenceBtn = $('.new-project-btn'); // This class is used for both projects and evidence
                var newProjectContainer = $('.new-project-container');
                
                if (searchContainer.length && newEvidenceBtn.length) {
                    console.log('[Evidence Table Init] Moving new-evidence-btn next to search');
                    // Remove from current location
                    newEvidenceBtn.detach();
                    // Create a container div for the button
                    var buttonContainer = $('<div class="new-project-btn-container"></div>');
                    buttonContainer.append(newEvidenceBtn);
                    // Insert after search container
                    searchContainer.after(buttonContainer);
                    // Hide the original container if it's now empty
                    if (newProjectContainer.length && newProjectContainer.children().length === 0) {
                        newProjectContainer.hide();
                    }
                    // Add some styling to align them
                    var topContainer = tableWrapper.find('.datatable-top');
                    if (topContainer.length) {
                        topContainer.css('display', 'flex');
                        topContainer.css('align-items', 'center');
                        topContainer.css('justify-content', 'space-between');
                    }
                } else {
                    console.warn('[Evidence Table Init] Could not find search container or new-evidence-btn');
                    console.warn('[Evidence Table Init] searchContainer:', searchContainer.length, 'newEvidenceBtn:', newEvidenceBtn.length);
                }
                hideLoader();
            }, 100);
        } catch (error) {
            console.error('[Evidence Table Init] Error initializing DataTable:', error);
            console.error('[Evidence Table Init] Error stack:', error.stack);
            // Hide loader even if there's an error
            hideLoader();
        }
    }

    // Try to initialize immediately
    console.log('[Evidence Table Init] Attempting initial initialization');
    initEvidenceTable();

    // Also try after a short delay in case table is loaded dynamically
    setTimeout(function() {
        console.log('[Evidence Table Init] Attempting delayed initialization (500ms)');
        initEvidenceTable();
        // If still not initialized after delay, hide loader anyway
        if (!evidenceDataTable) {
            setTimeout(function() {
                hideLoader();
            }, 100);
        }
    }, 500);

    // Use MutationObserver for better performance and modern approach
    if (typeof MutationObserver !== 'undefined') {
        console.log('[Evidence Table Init] Setting up MutationObserver');
        var isInitializing = false;
        var observer = new MutationObserver(function(mutations) {
            // Skip if already initializing or already initialized
            if (isInitializing || evidenceDataTable) {
                return;
            }
            
            var shouldInit = false;
            var table = document.querySelector('#userEvidenceTable');
            
            // Only initialize if table exists and doesn't have DataTable wrapper yet
            if (table && !table.closest('.datatable-wrapper')) {
                mutations.forEach(function(mutation) {
                    if (mutation.addedNodes.length) {
                        for (var i = 0; i < mutation.addedNodes.length; i++) {
                            var node = mutation.addedNodes[i];
                            if (node.nodeType === 1) { // Element node
                                if ($(node).find('#userEvidenceTable').length || $(node).is('#userEvidenceTable')) {
                                    console.log('[Evidence Table Init] MutationObserver detected table added to DOM');
                                    shouldInit = true;
                                    break;
                                }
                            }
                        }
                    }
                });
            }
            
            if (shouldInit && table && !table.closest('.datatable-wrapper')) {
                console.log('[Evidence Table Init] MutationObserver triggering initialization');
                isInitializing = true;
                setTimeout(function() {
                    initEvidenceTable();
                    isInitializing = false;
                    // If still not initialized after MutationObserver attempt, hide loader anyway
                    if (!evidenceDataTable) {
                        setTimeout(function() {
                            hideLoader();
                        }, 200);
                    }
                }, 100);
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        console.log('[Evidence Table Init] MutationObserver active');
    } else {
        console.warn('[Evidence Table Init] MutationObserver not available');
    }
});
